import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { useFormContext } from 'react-hook-form';
// Api
import { GET_STORE_BY_HOST_ID } from 'api/interview/queries';
// Types
import {
  GetStoreByHostId,
  GetStoreByHostIdVariables,
} from 'api/interview/types/GetStoreByHostId';
import { ScheduleInterviewFormValues } from 'components/UserScheduleInterview/ScheduleInterviewGuestModal/ScheduleInterviewGuestModal';
// Helpers
import { extractOrganizer, Organizer } from 'helpers/interview';

/**
 * When slots come from every matching host, each slot carries the host's
 * userId. Resolves the host of the slot the guest picked so the page can
 * show them the way a direct calendar link shows its single host.
 */
export const useSelectedSlotOrganizer = ({
  skip,
}: {
  skip: boolean;
}): Organizer | undefined => {
  const { watch } = useFormContext<ScheduleInterviewFormValues>();
  const selectedTimeSlot = watch('selectedTimeSlot');
  const selectedUserId = watch('selectedUserId');
  const slotHostId = !skip && selectedTimeSlot ? selectedUserId : undefined;

  const { data } = useQuery<GetStoreByHostId, GetStoreByHostIdVariables>(
    GET_STORE_BY_HOST_ID,
    {
      variables: {
        input: { id: slotHostId as string },
        withFollowerCount: true,
      },
      skip: !slotHostId,
    }
  );

  return useMemo(() => {
    const store = data?.store;

    return slotHostId && store?.id === slotHostId
      ? extractOrganizer(store)
      : undefined;
  }, [data, slotHostId]);
};
